__turbopack_context__.v({
  "backless": "FileUploader-module__aGnKFW__backless",
  "largeIcon": "FileUploader-module__aGnKFW__largeIcon",
  "link": "FileUploader-module__aGnKFW__link",
  "mediumIcon": "FileUploader-module__aGnKFW__mediumIcon",
});
